// material-ui
import { List } from '@mui/material';

import HeaderMenuItem from 'components/HeaderMenuItem';

// assets
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import { BarsOutlined } from '@ant-design/icons';

type Props = Readonly<{
  selectedIndex: number;
  handleListItemClick: (_: React.MouseEvent<HTMLDivElement>, index: number, route?: string) => void;
}>;

export default function SettingTab({ selectedIndex, handleListItemClick }: Props) {
  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <HeaderMenuItem
        icon={<QuestionCircleOutlined />}
        onClick={(e) => handleListItemClick(e, 1, '/support/help')}
        selected={selectedIndex === 1}
        titleId="help"
      />

      <HeaderMenuItem
        icon={<BarsOutlined />}
        onClick={(e) => handleListItemClick(e, 2, '/support/faqs')}
        selected={selectedIndex === 2}
        titleId="faqs"
      />
    </List>
  );
}
